export const VALIDATION_PATTERNS = {
  EMAIL: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,

  REGISTER: {
    USER: /^[a-zA-Z]([a-zA-Z0-9._-]*[a-zA-Z0-9])?$/,
    DOMAIN: /^[A-Za-z0-9][A-Za-z0-9-_#*.]*\.[A-Za-z0-9]+$/,
    PASSWORD: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+={}[\]:;"'|\\<>,.?/~`]).{8,}$/,
    NAME: /^[a-zA-Z0-9\.\-\sÃÇÁÕÂÔÓÉÍÚãçáõâôóéíú_]+[a-zA-Z0-9\s\.\-\sÃÇÁÕÂÔÓÉÍÚãçáõâôóéíú_]*$/,
    WEBSITE: /^(https?:\/\/)?(www\.)?[a-zA-Z0-9]+([\-\.]{1}[a-zA-Z0-9]+)*\.[a-zA-Z0-9]{2,}(:[0-9]{1,5})?(\/.*)?$/,

    NUMBERS_LETTERS_SPECIAL: /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#\$%\^&\*])[a-zA-Z\d!@#\$%\^&\*]{3,}$/,
    AT_LEAST_8_DIGITS: /^.{8,}$/,
    AT_LEAST_1_SPECIAL_CHARACTER: /[!@#$%^&*()_\-+={}[\]:;"'|\\<>,.?/~`]/,
    AT_LEAST_1_LOWERCASE: /.*[a-z].*/,
    AT_LEAST_1_UPPERCASE: /.*[A-Z].*/,
    AT_LEAST_1_NUMBER: /.*[0-9].*/,
  },
} as const;
